import { DetailedHTMLProps, IframeHTMLAttributes } from "react";
import { GeoLocation, GoogleMapsQuery } from "../../../graphql/operations";
import styles from "./GoogleMapsFrame.module.scss";
const apiKey = process.env.GOOGLE_MAPS_API_KEY;

export type GoogleMapsQueryInput = Pick<
  GoogleMapsQuery,
  "placeId" | "geoLocation"
>;

const geoLocationToQueryString = (geoLocation: GeoLocation) =>
  `${geoLocation.lat},${geoLocation.lng}`;

const generateEmbeddedGoogleMapsUrl = (query: GoogleMapsQueryInput) =>
  `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${
    "placeId" in query
      ? `place_id:${query.placeId}`
      : geoLocationToQueryString(query.geoLocation)
  }`;

export const generateGoogleMapsUrl = (query: GoogleMapsQueryInput) => {
  const scrubbedQuery = removeNullValues(query) as GoogleMapsQueryInput;

  return `https://www.google.com/maps/search/?api=1&query=${
    "placeId" in scrubbedQuery
      ? `Google&query_place_id=${scrubbedQuery.placeId}`
      : geoLocationToQueryString(scrubbedQuery.geoLocation)
  }`;
};

export type GoogleMapsFrameProps = {
  query: GoogleMapsQueryInput;
} & DetailedHTMLProps<
  IframeHTMLAttributes<HTMLIFrameElement>,
  HTMLIFrameElement
>;

const removeNullValues = (object: { [k: string]: unknown }) =>
  Object.fromEntries(
    Object.entries(object).filter(([_, value]) => value !== null)
  );

export default function GoogleMapsFrame({
  query,
  ...iframeProps
}: GoogleMapsFrameProps) {
  return (
    <iframe
      className={styles.GoogleMapsFrame}
      loading="lazy"
      src={generateEmbeddedGoogleMapsUrl(
        removeNullValues(query) as GoogleMapsQueryInput
      )}
      {...iframeProps}
    ></iframe>
  );
}
